// ================================
// INSTALL PROMPT (add to home screen)
// Chrome/Edge/Android fire `beforeinstallprompt` once, early — sometimes
// before any React component has mounted — and only hand you the install
// trigger through that event object. This listens at module load (so it's
// never missed) and caches it until something calls promptInstall().
//
// iOS Safari never fires that event at all; there's no programmatic install
// trigger there, Apple only supports the manual Share -> Add to Home Screen
// path, which the useInstallPrompt hook below surfaces via isIOS().
// ================================
let deferredPrompt = null;
const listeners = new Set();

function notify() { listeners.forEach(fn => fn()); }

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export function isIOS() {
  if (typeof window === 'undefined') return false;
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

export function canPromptInstall() {
  return !!deferredPrompt;
}

export async function promptInstall() {
  if (!deferredPrompt) return null;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  notify();
  return choice;
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
